import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { WhiteLayout, SectionHeadLayout } from "netcompany-mdx-slide";
import oo_principles from "./assets/principles-of-oo.png";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SectionHeadLayout title={"Summary"} mdxType="SectionHeadLayout" />
    <hr></hr>
    <WhiteLayout title={"Summary"} mdxType="WhiteLayout">
  <div style={{
        flex: "1",
        position: "relative"
      }}>
    <div style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          alignContent: "center",
          flexDirection: "column"
        }}>
      <img src={oo_principles} style={{
            maxHeight: "100%"
          }} alt="oo_principles" />
    </div>
  </div>
    </WhiteLayout>
    <hr></hr>
    <WhiteLayout title={"Summary"} mdxType="WhiteLayout">
      <ul>
        <li parentName="ul">
          <p parentName="li">{`The goal of software design is to write the code that:`}</p>
          <ul parentName="li">
            <li parentName="ul">{`meet the customer needs.`}</li>
            <li parentName="ul">{`cost-effectively change by developer.`}</li>
          </ul>
        </li>
        <li parentName="ul">
          <p parentName="li">{`The OOP is the guidance to design a robust application.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`The Abstraction is the foundation to build other OOP principles.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`The OOP is not just about design the domain objects.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Practice OOP from fresher level will build up the system thinking.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Apply OOP will make the project more complex and cost the runtime resources.`}</p>
        </li>
      </ul>
    </WhiteLayout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      